import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const accountSearchResultNoAccessUsersSlice = getCachedTableDataSlice<
    Record<string, number>,
    AccountSearchCriteria,
    AccountSortField,
    AccountSearchFiltering
>('accountSearchResultNoAccessUsers');

export const accountSearchResultNoAccessUsersActions = accountSearchResultNoAccessUsersSlice.actions;

const accountSearchResultNoAccessUsersCacheSelector: CachedTableCacheSelector<Record<string, number>>
    = state => state.accountSearchResult.noAccessUsers.cache;
export const accountSearchResultNoAccessUsersDataSelector: CachedTableDataSelector<Record<string, number>>
    = state => state.accountSearchResult.noAccessUsers;
export const accountSearchResultNoAccessUsersResultSelector = getCachedTableResultSelector(
    accountSearchResultNoAccessUsersCacheSelector,
    accountSearchResultStateSelector,
);
